import { computed } from 'vue';
const isAnnualInterval = val => {
  if (!val) return false;
  const s = String(val).toLowerCase();
  return ['annual', 'annually', 'year', 'yearly'].includes(s);
};
export function usePricingCalculations({
  plan,
  interval,
  seats,
  subscription
}) {
  // Calculate pricing breakdown and display amounts
  const priceBreakdown = computed(() => {
    try {
      const planData = plan && plan.value || subscription && subscription.value && subscription.value.plan || {};
      const seatsCount = Number(seats && seats.value) || Number(subscription && subscription.value && subscription.value.seatsRequired) || Number(subscription && subscription.value && subscription.value.currentPaidSeats) || Number(planData.seats) || 0;
      const planInterval = planData.interval;
      const annual = isAnnualInterval(interval && interval.value) || isAnnualInterval(planInterval);
      const months = annual ? 12 : 1;

      // Determine per-seat monthly price
      let perSeatMonthly = null;
      if (planData.monthlyPrice) perSeatMonthly = Number(planData.monthlyPrice);else if (planData.annualPrice) perSeatMonthly = Number(planData.annualPrice) / 12;else if (planData.price) perSeatMonthly = Number(planData.price);
      const perSeatDisplay = perSeatMonthly ? `$${perSeatMonthly.toFixed(2)} per seat` : '';
      return `${seatsCount} seats × ${months} month${months > 1 ? 's' : ''} × ${perSeatDisplay}`.trim();
    } catch (e) {
      return '';
    }
  });

  // Calculate total amount using formula: seats * months * per-seat-monthly-price
  const totalAmount = computed(() => {
    const planData = plan && plan.value || subscription && subscription.value && subscription.value.plan || {};
    const seatsCount = Number(seats && seats.value) || Number(subscription && subscription.value && subscription.value.seatsRequired) || Number(subscription && subscription.value && subscription.value.currentPaidSeats) || Number(planData.seats) || 0;
    const planInterval = planData.interval;
    const annual = isAnnualInterval(interval && interval.value) || isAnnualInterval(planInterval);
    const months = annual ? 12 : 1;
    let perSeatMonthly = null;
    if (planData.monthlyPrice) perSeatMonthly = Number(planData.monthlyPrice);else if (planData.annualPrice) perSeatMonthly = Number(planData.annualPrice) / 12;else if (planData.price) perSeatMonthly = Number(planData.price);
    return seatsCount * months * (Number(perSeatMonthly) || 0);
  });

  // Display amount based on billing period - monthly for monthly billing, yearly for annual billing
  const formattedDisplayAmount = computed(() => {
    const planData = plan && plan.value || subscription && subscription.value && subscription.value.plan || {};
    const planInterval = planData.interval;
    const annual = isAnnualInterval(interval && interval.value) || isAnnualInterval(planInterval);
    if (annual) {
      // For annual billing, show the total yearly amount
      return Number(totalAmount.value).toFixed(2);
    } else {
      // For monthly billing, show the monthly amount
      return Number(totalAmount.value).toFixed(2);
    }
  });

  // Display text for billing period
  const billingPeriodText = computed(() => {
    const planData = plan && plan.value || subscription && subscription.value && subscription.value.plan || {};
    const planInterval = planData.interval;
    const annual = isAnnualInterval(interval && interval.value) || isAnnualInterval(planInterval);
    return annual ? 'per year' : 'per month';
  });
  return {
    priceBreakdown,
    totalAmount,
    formattedDisplayAmount,
    billingPeriodText
  };
}